module.exports = __webpack_public_path__ + "img/edge-21.44cbea86.jpg";